
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/powerstream",
      function () {
        return require("private-next-pages/powerstream/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/powerstream"])
      });
    }
  